import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, ActivationEnd, Event, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { processTitleStyles } from 'src/app/helper';
import { NewsItem } from 'src/app/interfaces';
import { UnsubscribeComponent } from '../unsubscribe.component';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TagComponent extends UnsubscribeComponent {

  news: NewsItem[] = [];
  tag: string = null;
  page: number = 1;

  constructor(
    private router: Router,
    private cdr: ChangeDetectorRef,
    private title: Title,
	private apiService: ApiService
  ) {
    super();
    this.router.events.pipe(takeUntil(this.unsubscribe)).subscribe((event: Event) => {
      if (event instanceof ActivationEnd) {
        this.setData(event.snapshot);
      }
    });
    this.cdr.detach();
  }

  loadNews(): void {
	  this.apiService.getNews({
		  topicId: null,
		  count: 20,
		  start: (this.page - 1) * 20,
		  tag: this.tag,
		  search: null
	  }).pipe(takeUntil(this.unsubscribe)).subscribe((news) => {
		  processTitleStyles(news);
		  this.news.push(...news);
		  this.cdr.detectChanges();
	  });
  }

  nextPage(): void {
	  this.page++;
	  this.loadNews();
  }

  setData(activatedRouteSnapshot: ActivatedRouteSnapshot): void {
    this.tag = activatedRouteSnapshot.paramMap.get('tag');
    this.news = activatedRouteSnapshot.data.news;
    processTitleStyles(this.news);
    this.title.setTitle('Címke - ' + this.tag);
    this.cdr.detectChanges();
  }

}
